import React, { Component } from "react";
import "./ContentSearch.css";
import DropStatus from "./DropStatus";
import DropState from "./DropState";
import DropSources from "./DropSources";
import Cancel from "@safecv/assets/Images/cancel.png";
import { DebounceInput } from "react-debounce-input";

class ContentSearch extends Component {
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div>
            <h2 className="styling">{this.props.count} Plans</h2>
          </div>
          <DebounceInput
            minLength={1}
            debounceTimeout={500}
            className="searchbox"
            type="text"
            placeholder="Search Plan Name/JobId"
            value={this.props.inputVal === null ? "" : this.props.inputVal}
            onChange={(e) => this.props.handleInputChange(e.target.value)}
          />
          <DropState
            activePage={this.props.activePage}
            state={this.props.state}
            states={this.props.states}
            jurisdiction={this.props.jurisdiction}
            stateJurisdiction={this.props.stateJurisdiction}
            handleStateListChange={this.props.handleStateListChange}
            handleJurisdictionListChange={
              this.props.handleJurisdictionListChange
            }
            selectedjurisdiction={this.props.selectedjurisdiction}
            selected_state={this.props.selected_state}
            planTypeFilterData={this.props.planTypeFilterData}
            handlePlanTypeChange= {this.props.handlePlanTypeChange}
            planType={this.props.planType}
          />
          <DropSources
            sourceOfPlan={this.props.sourceOfPlan}
            selectedSource={this.props.selected_source}
            handleSourceListChange={this.props.handleSourceListChange}
          />
          <DropStatus
            statuses={this.props.statuses}
            handleStatusListChange={this.props.handleStatusListChange}
            selected_status={this.props.selected_status}
          />
          <span className="resetButton" onClick={this.props.resetFilters}>
            <img className="cancel-icon-styl" src={Cancel} alt="cancel"></img>
            Reset All
          </span>
        </div>
      </div>
    );
  }
}

export default ContentSearch;
